'use client'

import { Button } from '@vinted/web-ui'

import { navigateToPage } from '@marketplace-web/browser/browser-navigation-util'
import { clickEvent } from '@marketplace-web/item-upload/listing-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useSession } from '@marketplace-web/shared/session-data'

import { EDIT_ITEM_URL } from '../../constants/routes'
import { ItemPageEditActionModel } from './types'

type Props = {
  editActionPluginModel: ItemPageEditActionModel | undefined
}

const ItemPageEditActionPlugin = ({ editActionPluginModel }: Props) => {
  const translate = useTranslate('item')
  const { track } = useTracking()
  const currentUserId = useSession().user?.id

  if (!editActionPluginModel) return null

  const { id, userId, canEdit } = editActionPluginModel
  const isViewingOwnItem = userId === currentUserId

  const handleButtonClick = () => {
    track(
      clickEvent({
        target: 'edit_item',
        screen: 'item',
        targetDetails: JSON.stringify({
          item_id: id,
          user_id: userId,
        }),
      }),
    )

    navigateToPage(EDIT_ITEM_URL(id))
  }

  if (!isViewingOwnItem) return null
  if (!canEdit) return null

  return (
    <Button
      text={translate('actions.edit')}
      onClick={handleButtonClick}
      size="medium"
      testId="item-edit-button"
    />
  )
}

export default ItemPageEditActionPlugin
